import { render } from "./Index.vue?vue&type=template&id=ec08e072&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=ec08e072&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ec08e072"

export default script